module.exports = __webpack_public_path__ + "img/stock3.062a126d.png";